import appTheme from "features/home/jss/appTheme";
import config from "../../config";
import { id } from "date-fns/locale";
export {
  distributeABI,
  distributeNFTABI,
  erc20ABI,
  erc721ABI,
  masterMagpieABI,
  masterRadiantABI,
  vlMGPABI,
} from "./abi";
export { contracts } from "./contracts";
export { pools, rewardToCoingeckoIdMap } from "./pools";

export const images = {};
const context = require.context("assets/img", false, /\.(png|jpe?g|svg|gif)$/);

context.keys().forEach((item, index) => {
  images[item.replace("./", "")] = context(item);
});

export const defaultImage = "empty-token.png";

export const apiUrl = config.apiUrl;
export const socketIOUrl = config.socketIOUrl;

export const supportCenterBaseUrl = config.supportCenterBaseUrl;
export const adamUrl = config.adamUrl;

export const XMTP_ENV = config.xmtpEnv;
export const PUSH_ENV = config.pushEnv;

export const widgetJsUrl = (version) => {
  return version
    ? `${config.widgetUrl}widget-${version?.replace(/\./g, "-")}.js`
    : `${config.widgetUrl}widget.js`;
};
export const websiteOptInJsUrl = (version) => {
  return version
    ? `${config.websiteOptInUrl}footer-widget-${version?.replace(
        /\./g,
        "-"
      )}.js`
    : `${config.websiteOptInUrl}footer-widget-latest.js`;
};
export const attributionJsUrl = (version) => {
  return version
    ? `${config.trackingUrl}tracking-${version?.replace(/\./g, "-")}.js`
    : `${config.trackingUrl}tracking.js`;
};
export const tokenApiBaseUrl = "https://api.1inch.io/v4.0/1";
export const nativeAddress = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
export const alchemyApiKey = "iGnhEUY1xDTVIN_WIl4bdkiFDWXHg22Z";

export const memberAvatarsMapping = {
  Admin: require(`assets/img/ic_alpacaPurple.svg`).default,
  Assistant: require(`assets/img/ic_alpacaGreen.svg`).default,
  Staff: require(`assets/img/ic_alpacaPink.svg`).default,
  Team: require(`assets/img/ic_alpacaYellow.svg`).default,
};

const renderChain = (name, img) => {
  return (
    <span className="startRow" style={{ flexWrap: "nowrap" }}>
      <img src={require("assets/img/" + img)} className="smIcon" />
      <span style={{ marginLeft: "4px" }}>{name}</span>
    </span>
  );
};

export const ecosystemList = [
  {
    label: renderChain("EVM", "ETH.png"),
    value: "evm",
    name: "EVM",
    logo_url: require("assets/img/ETH.png"),
  },
  {
    label: renderChain("Aptos", "aptos.png"),
    value: "aptos",
    name: "Aptos",
    logo_url: require("assets/img/aptos.png"),
  },
  {
    label: renderChain("Solana", "solana.png"),
    value: "solana",
    name: "Solana",
    logo_url: require("assets/img/solana.png"),
  },
];

export const solanaChainList = [
  {
    label: renderChain("Solana", "solana.png"),
    value: "solana",
    nativeToken: "solana",
    nativeTokenIcon: "solana.png",
    id: "solana",
    name: "Solana",
    logo_url: require("assets/img/solana.png"),
    explorer: "https://solscan.io/",
  },
  {
    label: renderChain("Eclipse", "eclipse.png"),
    value: "eclipse",
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    id: "eclipse",
    name: "Eclipse",
    logo_url: require("assets/img/eclipse.png"),
    explorer: "https://eclipsescan.xyz/",
    disabledMarketing: true,
    disabledFootprint: true,
  },
];

export const aptosChainList = [
  {
    label: renderChain("Aptos", "aptos.png"),
    value: "aptos",
    nativeToken: "APTOS",
    nativeTokenIcon: "aptos.png",
    id: "aptos",
    name: "Aptos",
    logo_url: require("assets/img/aptos.png"),
    explorer: "https://aptoscan.com/",
  },
];

export const chainList = [
  {
    label: renderChain("Ethereum", "ETH.png"),
    value: 1,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    id: 1,
    name: "Ethereum",
    logo_url: require("assets/img/ETH.png"),
    explorer: "https://etherscan.io",
  },
  {
    label: renderChain("Polygon", "polygon.png"),
    value: 137,
    nativeToken: "MATIC",
    nativeTokenIcon: "polygon.png",
    id: 137,
    name: "Polygon",
    logo_url: require("assets/img/polygon.png"),
    explorer: "https://polygonscan.com",
  },
  {
    label: renderChain("Arbitrum", "arbitrum.svg"),
    value: 42161,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Arbitrum",
    logo_url: require("assets/img/arbitrum.svg").default,
    id: 42161,
    explorer: "https://arbiscan.io",
  },
  {
    label: renderChain("BSC", "BSC.svg"),
    value: 56,
    id: 56,
    nativeToken: "BNB",
    nativeTokenIcon: "bsc.png",
    name: "BSC",
    logo_url: require("assets/img/BSC.svg").default,
    explorer: "https://bscscan.com",
  },
  {
    label: renderChain("Optimism", "op.png"),
    value: 10,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Optimism",
    id: 10,
    logo_url: require("assets/img/op.png"),
    explorer: "https://optimistic.etherscan.io",
  },
  {
    label: renderChain("Blast", "blast.png"),
    value: 81457,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Blast",
    id: 81457,
    logo_url: require("assets/img/blast.png"),
    explorer: "https://blastscan.io",
  },
  {
    label: renderChain("Manta", "manta.png"),
    value: 169,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Manta",
    id: 169,
    logo_url: require("assets/img/manta.png"),
    explorer: "https://pacific-explorer.manta.network",
  },
  {
    label: renderChain("Moonbeam", "moonbeam.png"),
    value: 1284,
    nativeToken: "GLMR",
    nativeTokenIcon: "glmr.png",
    name: "Moonbeam",
    id: 1284,
    logo_url: require("assets/img/moonbeam.png"),
    explorer: "https://moonscan.io",
  },
  {
    label: renderChain("Base", "base.png"),
    value: 8453,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Base",
    id: 8453,
    logo_url: require("assets/img/base.png"),
    explorer: "https://basescan.org",
  },
  {
    label: renderChain("zkSync", "zksync.png"),
    value: 324,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "zkSync",
    id: 324,
    logo_url: require("assets/img/zksync.png"),
    explorer: "https://era.zksync.network",
  },
  {
    label: renderChain("Linea", "linea.png"),
    value: 59144,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Linea",
    id: 59144,
    logo_url: require("assets/img/linea.png"),
    explorer: "https://lineascan.build",
  },
  {
    label: renderChain("Mantle", "mantle.png"),
    value: 5000,
    nativeToken: "MNT",
    nativeTokenIcon: "mantle.png",
    name: "Mantle",
    id: 5000,
    logo_url: require("assets/img/mantle.png"),
    explorer: "https://mantlescan.xyz",
  },
  {
    label: renderChain("Kaia", "kaia.png"),
    value: 8217,
    nativeToken: "KLAY",
    nativeTokenIcon: "kaia.png",
    name: "Kaia",
    id: 8217,
    logo_url: require("assets/img/kaia.png"),
    explorer: "https://kaiascan.io",
    disabledImport: true,
    disabledMarketing: true,
    disabledFootprint: true,
  },
  {
    label: renderChain("Soneium", "soneium.png"),
    value: 1868,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Soneium",
    id: 1868,
    logo_url: require("assets/img/soneium.png"),
    explorer: "https://soneium.blockscout.com",
  },
  {
    label: renderChain("Sei", "sei.png"),
    value: 1329,
    nativeToken: "SEI",
    nativeTokenIcon: "sei.png",
    name: "Sei",
    id: 1329,
    logo_url: require("assets/img/sei.png"),
    explorer: "https://seitrace.com/",
    disabledImport: true,
    disabledMarketing: true,
    disabledFootprint: true,
  },
  {
    label: renderChain("Cronos", "cronos.png"),
    value: 25,
    nativeToken: "CRO",
    nativeTokenIcon: "cronos.png",
    name: "Cronos",
    id: 25,
    logo_url: require("assets/img/cronos.png"),
    explorer: "https://cronoscan.com",
  },
  {
    label: renderChain("Metis", "metis.png"),
    value: 1088,
    nativeToken: "METIS",
    nativeTokenIcon: "metis.png",
    name: "Metis",
    id: 1088,
    logo_url: require("assets/img/metis.png"),
    explorer: "https://explorer.metis.io",
  },
  {
    label: renderChain("Bitlayer", "bitlayer.png"),
    value: 200901,
    nativeToken: "BTR",
    nativeTokenIcon: "bitlayer.png",
    name: "Bitlayer",
    id: 200901,
    logo_url: require("assets/img/bitlayer.png"),
    explorer: "https://www.btrscan.com",
  },
  {
    label: renderChain("Core", "core.png"),
    value: 1116,
    nativeToken: "core",
    nativeTokenIcon: "core.png",
    name: "Core",
    id: 1116,
    logo_url: require("assets/img/core.png"),
    explorer: "https://scan.coredao.org",
  },
  {
    label: renderChain("Scroll", "scroll.png"),
    value: 534352,
    nativeToken: "SCR",
    nativeTokenIcon: "scroll.png",
    name: "Scroll",
    id: 534352,
    logo_url: require("assets/img/scroll.png"),
    explorer: "https://scrollscan.com",
  },
  {
    label: renderChain("OpBNB", "opbnb.png"),
    value: 204,
    nativeToken: "BNB",
    nativeTokenIcon: "opbnb.png",
    name: "OpBNB",
    id: 204,
    logo_url: require("assets/img/opbnb.png"),
    explorer: "https://opbnb.bscscan.com",
  },
  {
    label: renderChain("Merlin", "merlin.png"),
    value: 4200,
    nativeToken: "MERL",
    nativeTokenIcon: "merlin.png",
    name: "Merlin",
    id: 4200,
    logo_url: require("assets/img/merlin.png"),
    explorer: "https://scan.merlinchain.io",
    disabledFootprint: true,
  },
  {
    label: renderChain("Gnosis", "gnosis.png"),
    value: 100,
    nativeToken: "GNO",
    nativeTokenIcon: "gnosis.png",
    name: "Gnosis",
    id: 100,
    logo_url: require("assets/img/gnosis.png"),
    explorer: "https://gnosisscan.io",
  },
  {
    label: renderChain("Morph", "morph.png"),
    value: 2818,
    nativeToken: "Morph",
    nativeTokenIcon: "morph.png",
    name: "Morph",
    id: 2818,
    logo_url: require("assets/img/morph.png"),
    explorer: "https://morphscan.org/",
  },
  {
    label: renderChain("Sonic", "sonic.png"),
    value: 146,
    nativeToken: "S",
    nativeTokenIcon: "sonic.png",
    name: "Sonic",
    id: 146,
    logo_url: require("assets/img/sonic.png"),
    explorer: "https://sonicscan.org",
  },
  {
    label: renderChain("Bob", "bob-network.png"),
    value: 60808,
    nativeToken: "ETH",
    nativeTokenIcon: "ETH.png",
    name: "Bob",
    id: 60808,
    logo_url: require("assets/img/bob-network.png"),
    explorer: "https://explorer.gobob.xyz",
  },
  {
    label: renderChain("Berachain", "bera.png"),
    value: 80094,
    nativeToken: "BERA",
    nativeTokenIcon: "bera.png",
    name: "Berachain",
    id: 80094,
    logo_url: require("assets/img/bera.png"),
    explorer: "https://berascan.com",
  },
];

export const chainIdMapping = {
  eth: 1,
  bsc: 56,
  polygon: 137,
  arb: 42161,
  arbitrum: 42161,
  op: 10,
  optimism: 10,
  avax: 43114,
  okt: 66,
  ftm: 250,
  xdai: 100,
  celo: 42220,
  blast: 81457,
  mobm: 1284,
  manta: 169,
  linea: 59144,
  base: 8453,
  zksync: 324,
  mantle: 5000,
  mnt: 5000,
  kaia: 8217,
  soneium: 1868,
  sei: 1329,
  cro: 25,
  metis: 1088,
  btr: 200901,
  core: 1116,
  scrl: 534352,
  opbnb: 204,
  merlin: 4200,
  xdai: 100,
  morph: 2818,
  sonic: 146,
  bob: 60808,
  bera: 80094,
};

export const importTypes = [
  {
    name: "nft",
    label: "NFT Holders",
    value: "nft-holder",
    id: "nft-holder",
  },
  {
    name: "token",
    label: "Token Holders",
    value: "token-holder",
    id: "token-holder",
  },
  {
    name: "contract",
    label: "Contract Interactors",
    value: "contract-interactor",
    id: "contract-interactor",
  },
];

export const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#d2d0ee",
  "#b7f1a4",
  "#ae7d95",
  "#e194e6",
  "#696beb",
];

export const TAG_COLORS = [
  "#C2F0B6",
  "#D6BBFB",
  "#FDA19B",
  "#FEC84B",
  "#6CE9A6",
  "#7CD4FD",
  "#A4BCFD",
  "#BDB4FE",
  "#FAA7E0",
  "#EBD9B7",
  "#D0D5DD",
  "#EABBFB",
  "#FDBE9B",
  "#FEAC4B",
  "#6CE9E2",
  "#7CB0FD",
  "#BBFDA4",
  "#E0FF89",
  "#FCCEEE",
  "#F3E87F",
];

export const OPENSEA_TOP_LIST = [
  "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb", //CryptoPunk
  "0x05da517b1bf9999b7762eaefa8372341a1a47559", //KPR
  "0x60bb1e2aa1c9acafb4d34f71585d7e959f387769", //Art Gobbler
  "0x942bc2d3e7a589fe5bd4a5c6ef9727dfd82f5c8a", //Friendship Bracelets by Alexis André
  "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7", //Meebits
  "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b", //CloneX
  "0x34d85c9cdeb23fa97cb08333b511ac86e1c4e258", //Otherdeed for Otherside
  "0x60e4d786628fea6478f785a6d7e704777c86a7c6", //Mutant Ape
  "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d", //Bored Ape
  "0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85", //ENS
];

export const OPENSEA_TOP_LIST_MAP = {
  "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb": "CryptoPunk",
  "0x05da517b1bf9999b7762eaefa8372341a1a47559": "KPR",
  "0x60bb1e2aa1c9acafb4d34f71585d7e959f387769": "Art Gobbler",
  "0x942bc2d3e7a589fe5bd4a5c6ef9727dfd82f5c8a":
    "Friendship Bracelets by Alexis André",
  "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7": "Meebits",
  "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b": "CloneX",
  "0x34d85c9cdeb23fa97cb08333b511ac86e1c4e258": "Otherdeed for Otherside",
  "0x60e4d786628fea6478f785a6d7e704777c86a7c6": "Mutant Ape",
  "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d": "Bored Ape",
  "0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85": "ENS",
};

export const defaultThemeConfig = {
  theme: (mode) => appTheme(mode),
  headerLogo: require("assets/img/header.svg").default,
};

export const entityConfig = {
  default: {
    mirrorUrl: "",
    enableMagic: false,
  },
  jeff: {
    mirrorUrl: "https://app.radiant.capital/#/dashboard",
    chains: [
      { label: "ARB", value: 42161 },
      { label: "BSC", value: 56 },
    ],
    enableMagic: false,
  },
  radiant: {
    mirrorUrl: "https://app.radiant.capital/#/dashboard",
    chains: [
      { label: "ARB", value: 42161 },
      { label: "BSC", value: 56 },
    ],
    enableMagic: false,
  },
};

export const objectiveList = [
  { label: "All", value: "" },
  { label: "Token Transfer In", value: "tokenIn" },
  { label: "Token Transfer Out", value: "tokenOut" },
  { label: "Mint NFT", value: "mintNFT" },
  { label: "Contract Interaction", value: "contract" },
];

export const cexList = [
  {
    label: "Binance",
    id: "Binance",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/270.png",
  },
  {
    label: "Bybit",
    id: "Bybit",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/521.png",
  },
  {
    label: "Coinbase",
    id: "Coinbase",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/89.png",
  },
  {
    label: "OKX",
    id: "OKX",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png",
  },
  {
    label: "Upbit",
    id: "Upbit",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/351.png",
  },
  {
    label: "Bitget",
    id: "Bitget",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/513.png",
  },
  {
    label: "MEXC",
    id: "MEXC",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/544.png",
  },
  {
    label: "KuCoin",
    id: "KuCoin",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/311.png",
  },
  {
    label: "Gate.io",
    id: "Gate.io",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/302.png",
  },
  {
    label: "Kraken",
    id: "Kraken",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/24.png",
  },
  {
    label: "Bitfinex",
    id: "Bitfinex",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/37.png",
  },
  {
    label: "BingX",
    id: "BingX",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/1064.png",
  },
  {
    label: "Crypto.com",
    id: "Crypto.com",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/1149.png",
  },
  {
    label: "Binance TR",
    id: "Binance TR",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/1375.png",
  },
  {
    label: "HTX",
    id: "HTX",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/102.png",
  },
  {
    label: "BitMart",
    id: "BitMart",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/406.png",
  },
  {
    label: "LBank",
    id: "LBank",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/333.png",
  },
  {
    label: "Bitstamp",
    id: "Bitstamp",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/70.png",
  },
  {
    label: "Bithumb",
    id: "Bithumb",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/200.png",
  },
  {
    label: "XT.COM",
    id: "XT.COM",
    icon: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/525.png",
  },
  {
    label: "Bittrex",
    id: "Bittrex",
    icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAALklEQVR4AWOgFPDP/48HUU8DLnGSnUqUM6inAZNNSw2YiHoaMAHJkUWH9EMhAABQ18JlE+LwGQAAAABJRU5ErkJggg==",
  },
  {
    label: "MoonPay",
    id: "MoonPay",
    icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAS1BMVEX///+7kP+kZ//Tt/+hX/9wAP94AP///P99AP+HIf/p2v+vev+POf+ONP+obv/gzP/t4f+0gv+jY/+5i//x5/++lf/Env/48f/Jp/+h5VjdAAAAcklEQVR4AdXMtRHAQBAEwRPsihnzT1TMD77G7aqRv+e4ntF8ECYNEIZ0xVDEEI58ipM0ywuRMoL/tQoMQ6Jez19rEG5x1U8twiMUCnY8kbmC+YVhZsNUwf5CJgoOOBGxKI04rFJtVS6hEW1Dn+ddK/9tBlQVBSPChPAYAAAAAElFTkSuQmCC",
  },
  {
    label: "FTX",
    id: "FTX",
    icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAV1BMVEX///+Vz92Ax9h1w9VHtMsAo8AApMEAnLwAp8MAoL613Oeo1+O85/DG6vLV8PZOx91Yyd580+Of3+tfy9+s4+7Z9vr1/P257/Wo6/Pq+vyt7PTL8vjK8vgDc8V6AAAAa0lEQVR4AcXMwwHAQAAEwI1t567/NmPbme8Cv2LYEW4U8oI4JI1DeUQ5EQoj41tVG8MBegmG3jHRs2zbtuDYLcsdhp7nlaHXsA+EB25d3/dd6H7HxClBKcSyKC4ka2GaphfDeCMklBAa4m85xdIMfMpgcBwAAAAASUVORK5CYII=",
  },
];
